export default __webpack_public_path__ + "static/media/earth.5a1ee882.svg";